module.exports = __webpack_public_path__ + "static/media/welcome_image1.ba97d14c.jpg";